import { useState } from "react";
import PrivaryTax from "./PrivaryTax";
import ThirdPartyAgreement from "./ThirdPartyAgreement";

const DBApplicationForm = ({ formData, handleChange, handleSubmit }) => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showThirdParty, setShowThirdParty] = useState(false);

  return (
    <div className="db-form-container">
     <form onSubmit={handleSubmit} className="db-form">
        <input 
          type="text" 
          name="name" 
          placeholder="이름" 
          value={formData.name} 
          onChange={handleChange} 
          required 
          className="db-form-input" 
        />
        <input 
          type="text" 
          name="phone" 
          placeholder="연락처" 
          value={formData.phone} 
          onChange={handleChange} 
          required 
          className="db-form-input" 
        />
        <input 
          type="text" 
          name="industry" 
          placeholder="업종" 
          value={formData.industry} 
          onChange={handleChange} 
          required 
          className="db-form-input" 
        />
        <input 
          type="text" 
          name="region" 
          placeholder="지역" 
          value={formData.region} 
          onChange={handleChange} 
          required 
          className="db-form-input" 
        />
        <input 
          type="text" 
          name="revenue" 
          placeholder="월매출" 
          value={formData.revenue} 
          onChange={handleChange} 
          required 
          className="db-form-input" 
        />
        
        <div className="db-form-checkbox-container">
            <div>
  <label className="db-form-checkbox-label">
    <input 
      type="checkbox" 
      name="privacyPolicy" 
      checked={formData.privacyPolicy} 
      onChange={handleChange} 
      className="db-form-checkbox"
    />
    개인정보취급방침에 동의합니다  
  </label>

  <span onClick={() => setShowPrivacyPolicy(!showPrivacyPolicy)} className="privacy-toggle">
    [자세히보기]
  </span></div>
  <div>
  <label className="db-form-checkbox-label">
    <input 
      type="checkbox" 
      name="thirdPartyAgreement" 
      checked={formData.thirdPartyAgreement} 
      onChange={handleChange} 
      className="db-form-checkbox"
    />
    제3자 정보제공에 동의합니다  
  </label>
  <span onClick={() => setShowThirdParty(!showThirdParty)} className="privacy-toggle">
    [자세히보기]
  </span></div>
  {/* [자세히보기] 버튼 */}


</div>
{showPrivacyPolicy && <PrivaryTax />}
{showThirdParty && <ThirdPartyAgreement />}

        <button type="submit" className="db-form-submit-btn">신청하기</button>
      </form>
      
      <style jsx>{`
        .db-form-container {
          background: #1a1a1a;
          padding: 20px;
          text-align: center;
          color: white;
          width: 100%;
          margin: auto;
        }
        .db-form-input {
          width: 100%;
          padding: 10px;
          margin: 5px 0;
          border: none;
          font-size: 16px;
        }
        .db-form-checkbox-container {
        display: flex;
        flex-direction: row;
justify-content: space-between;
          text-align: left;
          margin-top: 10px;
        }
          .db-form-checkbox-container div {
          display: flex;
                  flex-direction: row;
                  font-size: 11px;

          }
        .db-form-checkbox-label {
          display: flex;
          align-items: center;
          font-size: 10px;
          cursor: pointer;
        }
        .privacy-toggle {
          color: #d4af72;
          text-decoration: underline;
          cursor: pointer;
          margin-left: 5px;
        }
        .privacy-policy-content {
        text-align: left;
          background: #333;
          padding: 10px;
          border-radius: 5px;
          font-size: 12px;
          margin-top: 5px;
        }
        .db-form-submit-btn {
          width: 100%;
          padding: 10px;
          background: #d4af72;
          border: none;
          border-radius: 5px;
          font-size: 18px;
          color: black;
          cursor: pointer;
          margin-top: 10px;
        }
        .db-form-submit-btn:hover {
          background: #c49c60;
        }
      `}</style>
    </div>
  );
};

export default DBApplicationForm;